import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import CreateMeetingModal from './CreateMeetingModal'; // 1. Import the new modal component

const Dashboard = () => {
    const [meetId, setMeetId] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false); // 2. State to control the modal
    const { user } = useAuth();
    const navigate = useNavigate();

    const handleJoinMeeting = (e) => {
        e.preventDefault();
        if (meetId.trim()) {
            navigate(`/meet/${meetId.trim()}`);
        }
    };

    const styles = {
        container: { padding: '2rem', maxWidth: '600px', margin: 'auto', textAlign: 'center' },
        input: { padding: '0.8rem', width: '80%', margin: '1rem 0', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' },
        button: { padding: '0.8rem 1.5rem', cursor: 'pointer', border: 'none', borderRadius: '5px', color: 'white', fontSize: '1rem' },
    };

    return (
        <>
            {/* 3. Render the modal conditionally based on the state */}
            {isModalOpen && <CreateMeetingModal onClose={() => setIsModalOpen(false)} />}

            <div style={styles.container}>
                <h1>Welcome, {user.first_name}!</h1>
                <p>Create a new meeting or enter an existing Meeting ID to join.</p>
                
                {user.role === 'super_admin' && (
                    <button 
                        onClick={() => setIsModalOpen(true)} // 4. This button now opens the modal
                        style={{ ...styles.button, background: '#16A34A', marginBottom: '1rem' }}
                    >
                        Create New Meeting
                    </button>
                )}

                <hr style={{ margin: '2rem 0' }} />

                <form onSubmit={handleJoinMeeting} aria-label="Join Meeting Form">
                    <label htmlFor="meetIdInput" style={{ display: 'none' }}>Meeting ID</label>
                    <input
                        id="meetIdInput"
                        type="text"
                        value={meetId}
                        onChange={(e) => setMeetId(e.target.value)}
                        placeholder="Enter Meeting ID"
                        style={styles.input}
                        required
                    />
                    <button type="submit" style={{ ...styles.button, background: '#2563EB' }}>
                        Join Meeting
                    </button>
                </form>
            </div>
        </>
    );
};

export default Dashboard;
